import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./assets/sass/vue/App.styles.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__